/* @flow */

import * as React from 'react';
import AppHeader from 'app/containers/parts/AppHeader';
import Container from 'app/components/layout/Container';
import Responsive from 'app/components/responsive/Responsive';

type Props = {
  children?: any,
  disableReferrerBack?: boolean,
  showAd?: boolean,
  size?: string,
  onBack?: () => void,
  title?: string,
  fullWidth?: boolean
};

const defaultProps = {
  children: undefined,
  disableReferrerBack: false,
  fullWidth: false,
  showAd: true,
  size: 'large',
  onBack: undefined,
  title: undefined
};

function Page({ children, showAd, size, title, fullWidth, onBack, disableReferrerBack }: Props) {
  return (
    <Responsive desktop>
      {isDesktop => (
        <Container
          className="appBodyContainer"
          size={size}
          gutterLargeDevices={isDesktop}
          fullWidth={fullWidth}
        >
          <AppHeader
            showAd={showAd}
            title={title}
            onBack={onBack}
            disableReferrerBack={disableReferrerBack}
          />
          {children}
        </Container>
      )}
    </Responsive>
  );
}

Page.defaultProps = defaultProps;

export default Page;
